import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import { AppLayout } from "@/components/app/AppLayout";
import Overview from "./pages/Overview";
import PerpsLayout from "./pages/perps/PerpsLayout";
import PerpsPerformance from "./pages/perps/PerpsPerformance";
import PerpsPositionsRisk from "./pages/perps/PerpsPositionsRisk";
import PerpsFunding from "./pages/perps/PerpsFunding";
import PerpsTrades from "./pages/perps/PerpsTrades";
import PerpsInsights from "./pages/perps/PerpsInsights";
import SpotLayout from "./pages/spot/SpotLayout";
import SpotPerformance from "./pages/spot/SpotPerformance";
import SpotHoldingsPnL from "./pages/spot/SpotHoldingsPnL";
import SpotTrades from "./pages/spot/SpotTrades";
import SpotInsights from "./pages/spot/SpotInsights";
import { Terms } from "./pages/Terms";
import { Privacy } from "./pages/Privacy";
import { Docs } from "./pages/Docs";
import NotFound from "./pages/NotFound";

const App = () => (
  <TooltipProvider>
    <Toaster />
    <Sonner />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/dashboard" element={<Navigate to="/app" replace />} />
        <Route path="/app" element={<AppLayout />}>
          <Route index element={<Overview />} />
          <Route path="perps" element={<PerpsLayout />}>
            <Route index element={<Navigate to="performance" replace />} />
            <Route path="performance" element={<PerpsPerformance />} />
            <Route path="positions-risk" element={<PerpsPositionsRisk />} />
            <Route path="funding" element={<PerpsFunding />} />
            <Route path="trades" element={<PerpsTrades />} />
            <Route path="insights" element={<PerpsInsights />} />
          </Route>
          <Route path="spot" element={<SpotLayout />}>
            <Route index element={<Navigate to="performance" replace />} />
            <Route path="performance" element={<SpotPerformance />} />
            <Route path="holdings-pnl" element={<SpotHoldingsPnL />} />
            <Route path="trades" element={<SpotTrades />} />
            <Route path="insights" element={<SpotInsights />} />
          </Route>
        </Route>
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/docs" element={<Docs />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </TooltipProvider>
);

export default App;
